import React, { useEffect } from "react";
import Draggable from "react-draggable";
import { useDispatch, useSelector } from "react-redux";
import actions from "../actions";
import "../smartCharts.css";
import LoadingOverlay from "react-loading-overlay";
import Loader from "../../common/components/Loader";
import ReactTooltip from "react-tooltip";
import moment from "moment";

const SmartChartLog = ({ onShow, onCancel, selectedReportId }) => {
    const { getSmartChartLogResponse } = useSelector(state => state.smartChartReducer);

    const logs = getSmartChartLogResponse?.logs?.sections || [];
    const errors = getSmartChartLogResponse?.logs?.error || [];
    const summary = getSmartChartLogResponse?.logs?.summary;
    const warning = getSmartChartLogResponse?.logs?.warnings || getSmartChartLogResponse?.logs?.warning;

    const toMessageList = value => {
        if (!value) return [];
        if (Array.isArray(value)) return value.filter(Boolean);
        return [value];
    };
    const summaryList = toMessageList(summary);
    const warningList = toMessageList(warning);

    const workerStatus = getSmartChartLogResponse?.logs?.worker_status || getSmartChartLogResponse?.logs || {};
    const hasWorkerStatus = ["worker_alive", "worker_last_seen_seconds", "current_step", "current_step_seconds"].some(
        key => workerStatus?.[key] !== undefined && workerStatus?.[key] !== null
    );

    const formatDuration = seconds => {
        const value = Number(seconds);
        if (seconds === undefined || seconds === null || Number.isNaN(value)) return "-";
        if (value < 60) return `${Math.round(value)} sec`;
        const minutes = value / 60;
        if (minutes < 60) return `${Math.round(minutes)} min`;
        const hours = minutes / 60;
        return `${Math.round(hours * 10) / 10} hr`;
    };

    const dispatch = useDispatch();

    const handleRefresh = () => {
        dispatch(actions.getSmartChartLog({ export_id: selectedReportId }));
    };

    useEffect(() => {
        handleRefresh();
    }, []);

    const logNames = {
        FETCH_DATA: "Preparing Smart Chart Data",
        PROCESS_DOCUMENTS: "Processing Smart Chart Documents",
        MERGE_DOCUMENT: "Merging Prepared Documents",
        UPLOAD_DOCUMENT: "Smart Chart Document Upload"
    };

    return (
        <div id="modalId" className="modal modal-region modal-img-magamnt modal-caption col-md-12 logs-list-popup" style={{ display: "block" }}>
            <LoadingOverlay active={getSmartChartLogResponse?.loading} spinner={<Loader />} fadeSpeed={10}>
                <Draggable cancel=".not-draggable" handle=".draggable">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <button
                                type="button"
                                className="close not-draggable"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onCancel && onCancel()}
                            >
                                <span aria-hidden="true">
                                    <img src="/img/close.svg" alt="" />
                                </span>
                            </button>
                            <div className="modal-header draggable">
                                <div class="heading position-relative">
                                    <h5 className="modal-title"> Logs</h5>{" "}
                                    <button class="btn btn-edit btn-sm btn btn-primary mr-5" onClick={() => handleRefresh()}>
                                        {/* <span class="icon mr-1">
                                            <img src="/static/media/img-refresh.cd460e6ecf9b96b7c97b10ffb242e157.svg" alt="" />
                                        </span> */}
                                        <span class="text">Refresh</span>
                                    </button>
                                </div>
                            </div>

                            <div className="modal-body region-otr core-rpt-dt-mod sm-chart-upload cursor-default">
                                {getSmartChartLogResponse?.logs ? (
                                    <div className="col-md-12 main-sec">
                                        <div className="rgt">
                                            <span className="sel-chart-badge">Status : {getSmartChartLogResponse?.logs?.status || "-"}</span>
                                            {getSmartChartLogResponse?.logs?.export_duration && (
                                                <span className="sel-chart-badge ml-2">
                                                    Duration : {getSmartChartLogResponse?.logs?.export_duration || "null"}
                                                </span>
                                            )}
                                        </div>
                                        {getSmartChartLogResponse?.logs?.date_initiated && (
                                            <div className="rgt">
                                                <span className="sel-chart-badge">
                                                    Initiated At :{" "}
                                                    {getSmartChartLogResponse?.logs?.date_initiated
                                                        ? moment(getSmartChartLogResponse?.logs?.date_initiated).isValid()
                                                            ? moment(getSmartChartLogResponse?.logs?.date_initiated).format("MM-DD-YYYY hh:mm A")
                                                            : "null"
                                                        : "null"}
                                                </span>
                                            </div>
                                        )}
                                        {getSmartChartLogResponse?.logs?.date_done && (
                                            <div className="rgt">
                                                <span className="sel-chart-badge">
                                                    Completed At :{" "}
                                                    {getSmartChartLogResponse?.logs?.date_done
                                                        ? moment(getSmartChartLogResponse?.logs?.date_done).isValid()
                                                            ? moment(getSmartChartLogResponse?.logs?.date_done).format("MM-DD-YYYY hh:mm A")
                                                            : "null"
                                                        : "null"}
                                                </span>
                                            </div>
                                        )}
                                        {summaryList.length > 0 && (
                                            <div className="rgt">
                                                <span className="sel-chart-badge sm-chart-log-note">
                                                    <strong>Summary</strong>
                                                    {summaryList.map((item, index) => (
                                                        <p key={index}>{typeof item === "string" ? item : JSON.stringify(item)}</p>
                                                    ))}
                                                </span>
                                            </div>
                                        )}
                                        {warningList.length > 0 && (
                                            <div className="rgt">
                                                <span className="sel-chart-badge sm-chart-log-note sm-chart-log-warning">
                                                    <strong>Warnings</strong>
                                                    <ul>
                                                        {warningList.map((item, index) => (
                                                            <li key={index}>{typeof item === "string" ? item : JSON.stringify(item)}</li>
                                                        ))}
                                                    </ul>
                                                </span>
                                            </div>
                                        )}
                                        {hasWorkerStatus && (
                                            <div className="rgt">
                                                <span className="sel-chart-badge sm-chart-log-note sm-chart-log-worker">
                                                    <strong className="sm-chart-log-worker-title">Report Generation Task Status</strong>
                                                    <p>
                                                        <strong>Task Status:</strong>{" "}
                                                        {workerStatus?.worker_alive === undefined || workerStatus?.worker_alive === null
                                                            ? "-"
                                                            : workerStatus.worker_alive
                                                            ? "Running"
                                                            : "Not running"}
                                                    </p>
                                                    <p>
                                                        <strong>Last activity:</strong>{" "}
                                                        {workerStatus?.worker_last_seen_seconds === undefined ||
                                                        workerStatus?.worker_last_seen_seconds === null
                                                            ? "-"
                                                            : Number(workerStatus.worker_last_seen_seconds) < 3
                                                            ? "just now"
                                                            : `${formatDuration(workerStatus.worker_last_seen_seconds)} ago`}
                                                    </p>
                                                    <p>
                                                        <strong>Current step:</strong> {workerStatus?.current_step || "-"}
                                                    </p>
                                                    <p>
                                                        <strong>Time spent on this step:</strong>{" "}
                                                        {formatDuration(workerStatus?.current_step_seconds)}
                                                    </p>
                                                </span>
                                            </div>
                                        )}
                                        <div className="form-row">
                                            <div className="form-group col-12 mb-4">
                                                <div className="log-list">
                                                    {logs?.map((log, index) => (
                                                        <p key={index}>
                                                            {Object.keys(logNames || {})?.find(e => e === log) ? (
                                                                <span className="logNames">{logNames[log] || log || "-"}</span>
                                                            ) : (
                                                                logNames[log] || log || "-"
                                                            )}
                                                        </p>
                                                    ))}
                                                </div>
                                            </div>

                                            {errors?.length > 0 && (
                                                <div className="form-group col-12 mb-4">
                                                    <label className="text-danger">Errors</label>

                                                    <div className="error-list">
                                                        {errors?.map((error, index) => (
                                                            <div key={index} className="error-log">
                                                                <p>
                                                                    <strong>Section:</strong> {error?.section}
                                                                    <span>
                                                                        {" "}
                                                                        <i data-tip data-for={`tooltip_${index}`} className="fas fa-info-circle" />
                                                                    </span>
                                                                </p>

                                                                <p>
                                                                    <strong>Exception Reason:</strong> {error?.exception_reason}
                                                                </p>
                                                                <br />

                                                                {/* Tooltip content */}
                                                                <ReactTooltip id={`tooltip_${index}`} place="left" effect="solid">
                                                                    <p>
                                                                        <strong>File Name:</strong> {error?.file_name}
                                                                    </p>
                                                                    <p>
                                                                        <strong>Line Number:</strong> {error?.line_number}
                                                                    </p>
                                                                    <p>
                                                                        <strong>Function Name:</strong> {error?.function_name}
                                                                    </p>
                                                                    {error?.more_details && (
                                                                        <p>
                                                                            <strong>More Detail:</strong>{" "}
                                                                            {typeof error.more_details === "string"
                                                                                ? error.more_details
                                                                                : JSON.stringify(error.more_details)}
                                                                        </p>
                                                                    )}
                                                                </ReactTooltip>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="form-row">
                                        <div className="form-group col-12 mb-4">
                                            <div className="log-list">No Logs Found</div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Draggable>
            </LoadingOverlay>
        </div>
    );
};

export default SmartChartLog;
